import useSWR from 'swr';
import { useCallback, useState } from 'react';
import urlResolver from 'edrolo/utils/URLResolver';
import { SAVE_STATUS } from 'edrolo/constants/SaveStatus';
import { fetcher, post } from './utils';
import { ChunkNote } from '../types/Hooks';

type StatusKeys = keyof typeof SAVE_STATUS;
type StatusValues = typeof SAVE_STATUS[StatusKeys];

export const useStudentChunkNote = (chunkId: number) => {
  const [status, setStatus] = useState<StatusValues | null>(null);

  const studentNoteUrl = urlResolver.reverse('api:student-chunk-note', {
    chunkId,
  });

  const { data, error, mutate } = useSWR(studentNoteUrl, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const updateStudentChunkNote = useCallback(
    async ({ studentNoteMarkdown: note }: ChunkNote) => {
      setStatus(SAVE_STATUS.SAVING);

      const options = {
        optimisticData: { ...data, note },
        rollbackOnError: true,
        revalidate: false,
      };

      try {
        await mutate(post(studentNoteUrl, { note }), options);
      } catch (error) {
        setStatus(SAVE_STATUS.ERROR);
        console.error(error);
      }

      setStatus(SAVE_STATUS.SAVED);
    },
    [data, mutate, studentNoteUrl]
  );

  return {
    data,
    loading: !data && !error,
    error,
    status,
    updateStudentChunkNote,
    mutate,
  };
};
